(() => {
  const panel = document.getElementById('zayian-currency');
  if (!panel) return;
  const select = panel.querySelector('select');
  const notice = panel.querySelector('[data-currency-notice]');
  const error = panel.querySelector('[data-currency-error]');
  const countries = window.ZayianCurrencyCountries || {};
  const codes = [...new Set(['USD', ...Object.values(countries)])].sort();
  const originals = new WeakMap();
  const pending = new Map();
  const preferenceKey = 'zayian.displayCurrency.v2';
  const rateKey = 'zayian.displayRates.v2';
  const locale = document.documentElement.lang || 'en';
  const names = new Intl.DisplayNames([locale], { type: 'currency' });
  let country = panel.dataset.country;
  let preference = 'auto', activeRate = null, generation = 0, queued = false, observer;
  const storage = name => { try { return window[name]; } catch { return null; } };
  const read = (name, key) => { try { return JSON.parse(storage(name).getItem(key)); } catch { return null; } };
  const write = (name, key, value) => { try { storage(name).setItem(key, JSON.stringify(value)); } catch {} };
  const saved = read('localStorage', preferenceKey);
  if (saved === 'auto' || codes.includes(saved)) preference = saved;
  for (const code of codes) {
    const option = document.createElement('option');
    option.value = code;
    option.textContent = code + ' — ' + names.of(code);
    select.append(option);
  }
  select.value = preference;
  const target = () => preference === 'auto' ? countries[country] || 'USD' : preference;
  const observe = () => observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-cents', 'data-base'] });
  const render = () => {
    observer.disconnect();
    const code = target();
    const active = code !== 'USD' && activeRate?.currency === code;
    const format = active ? new Intl.NumberFormat(locale, { style: 'currency', currency: code, currencyDisplay: 'symbol' }) : null;
    document.querySelectorAll('[data-zayian-money]').forEach(element => {
      const cents = Number(element.dataset.cents), base = element.dataset.base;
      if (base !== 'USD' || !Number.isFinite(cents) || cents < 0 || element.dataset.cents.trim() === '') return;
      const prior = originals.get(element);
      const key = base + ':' + cents;
      const state = !prior || prior.key !== key || element.textContent !== prior.output
        ? { key, original: element.textContent, output: element.textContent } : prior;
      state.output = active ? format.format(cents / 100 * activeRate.value) : state.original;
      if (element.textContent !== state.output) element.textContent = state.output;
      originals.set(element, state);
    });
    const auto = select.querySelector('option[value="auto"]');
    const autoLabel = panel.dataset.autoLabel + ' (' + (countries[country] || 'USD') + ')';
    if (auto.textContent !== autoLabel) auto.textContent = autoLabel;
    const text = panel.dataset.notice.replace('[currency]', code);
    if (notice.textContent !== text) notice.textContent = text;
    notice.hidden = !active;
    observe();
  };
  const getRate = code => {
    if (pending.has(code)) return pending.get(code);
    const promise = (async () => {
      const cached = read('localStorage', rateKey)?.[code], now = Date.now();
      if (cached && typeof cached.rate === 'number' && Number.isFinite(cached.rate) && cached.rate > 0 && now >= cached.fetchedAt && now - cached.fetchedAt < 86400000) return cached.rate;
      const response = await fetch('https://api.frankfurter.dev/v2/rate/usd/' + code.toLowerCase(), { credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(5000) });
      if (!response.ok) throw new Error('Rate unavailable');
      const data = await response.json(), age = now - Date.parse(data.date);
      if (data.base !== 'USD' || data.quote !== code || typeof data.rate !== 'number' || !Number.isFinite(data.rate) || data.rate <= 0 || !Number.isFinite(age) || age < -86400000 || age > 604800000) throw new Error('Invalid rate');
      const cache = read('localStorage', rateKey) || {};
      cache[code] = { rate: data.rate, fetchedAt: now };
      write('localStorage', rateKey, cache);
      return data.rate;
    })().finally(() => pending.delete(code));
    pending.set(code, promise);
    return promise;
  };
  const update = async () => {
    const current = ++generation, code = target();
    error.hidden = true;
    render();
    if (code === 'USD') return;
    try {
      const value = await getRate(code);
      if (current !== generation) return;
      activeRate = { currency: code, value };
      render();
    } catch {
      if (current !== generation) return;
      activeRate = null;
      error.hidden = false;
      render();
    }
  };
  observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  });
  select.addEventListener('change', () => {
    preference = select.value;
    write('localStorage', preferenceKey, preference);
    update();
  });
  window.addEventListener('storage', event => {
    if (event.key !== preferenceKey) return;
    const value = read('localStorage', preferenceKey);
    preference = value === 'auto' || codes.includes(value) ? value : 'auto';
    select.value = preference;
    update();
  });
  const detect = async () => {
    const cacheKey = 'zayian.visitorCountry.v1', cached = read('sessionStorage', cacheKey);
    if (cached?.code in countries && Date.now() >= cached.at && Date.now() - cached.at < 1800000) { country = cached.code; return; }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', signal: AbortSignal.timeout(3000) });
      if (!response.ok) return;
      const data = await response.json(), code = data.detected_values?.country?.handle;
      if (code in countries) { country = code; write('sessionStorage', cacheKey, { code, at: Date.now() }); }
    } catch {}
  };
  if (preference === 'auto') detect().finally(update);
  else update();
})();
